<template>
    <p class="d-flex mb-0"> 
        <v-list color="transparent" class="ma-0 pa-0">
            <v-list-item class="ma-0 pa-0">
                <v-list-item-avatar class="my-0 py-0" v-bind:class="{primary: (businessProfile.premiereProfileLogoImageURL || '') ==''}" :style="`background-position: center;background-repeat: no-repeat;background-size: cover;background-size: cover;background-image: url('${businessProfile.premiereProfileLogoImageURL || ''}')`">
                    <v-icon v-if="(businessProfile.premiereProfileLogoImageURL || '') ==''" dark>person</v-icon>
                </v-list-item-avatar>
            </v-list-item>
        </v-list>
        <v-text-field v-model="commentText" class="mr-5" rounded outlined placeholder="Write a comment" append-icon="send" @click:append="addNewComment" v-on:keyup.enter="addNewComment">
        </v-text-field>
    </p>
</template>
<script>
import { mapGetters } from 'vuex'

import {doc, increment, serverTimestamp, getFirestore, writeBatch} from 'firebase/firestore';
import {postDocRef} from "@/shared/firebase_utils";
export default {
    name: 'AddCommentTextfield',
    data() {
        return {
            commentText: '',
        };
    },
    props: {
        post: {
            type: Object,
            default: {},
        },
    },
    computed: mapGetters(['businessProfile', 'userProfile']),
    methods: {
        async addNewComment() {
            if(this.commentText != '') {
                var db = getFirestore();
                var batch = writeBatch(db);
                const newCommentRef = doc(db, 'comments');
                //Add a new comment to the post
                //var newCommentRef = db.collection('comments').doc();
                batch.set(newCommentRef, {
                    text: this.commentText,
                    createdAt: serverTimestamp(),
                    fullName: this.businessProfile.businessName,
                    businessProfileId: this.userProfile.businessProfileId,
                    postId: this.post.postId
                });
                const postRef = postDocRef(this.post.postId);
                //Update the number of comments for the given post
                batch.update(postRef, {noOfComments: increment(1)});
                // Commit the batch
                batch.commit().then( () =>{
                    this.commentText = ''; 
                });                
            }
        },
    },
}
</script>